export const ThemeIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.7"
        y="4.7"
        width="21.6"
        height="16.6"
        rx="1.3"
        stroke="black"
        strokeWidth="1.4"
      />
      <mask id="path-2-inside-1_5460_131910" fill="white">
        <rect x="3" y="7" width="7" height="12" rx="1" />
      </mask>
      <rect
        x="3"
        y="7"
        width="7"
        height="12"
        rx="1"
        stroke="black"
        strokeWidth="2.8"
        mask="url(#path-2-inside-1_5460_131910)"
      />
      <rect x="12" y="7" width="8" height="5" rx="1" fill="#1E1E1E" />
      <rect
        x="12"
        y="7"
        width="8"
        height="5"
        rx="1"
        fill="black"
        fillOpacity="0.2"
      />
      <mask id="path-4-inside-2_5460_131910" fill="white">
        <rect x="12" y="14" width="8" height="5" rx="1" />
      </mask>
      <rect
        x="12"
        y="14"
        width="8"
        height="5"
        rx="1"
        stroke="black"
        strokeWidth="2.8"
        mask="url(#path-4-inside-2_5460_131910)"
      />
    </svg>
  )
}
